import {ParsedUrlQuery} from 'querystring'

import {capitalizeFirstLetter} from '@vio/core/src/utils/string'

import {extractFilterSlugsFromTaxonomy} from './getFiltersFromTaxonomy'
import {buildFilterSuffix, getSortedFilters} from './getSeoSRPPath'

import type {SeoBreadcrumbItem} from 'seo/getBreadcrumb'
import type {SeoAttributes} from 'seo/seo-db/attributes'

type SeoBreadcrumbType = 'country' | 'city' | 'landmark' | 'filter'

export interface SeoBreadcrumb {
  type: SeoBreadcrumbType
  name: string
  path: string
}

interface GetSeoBreadcrumbParams {
  pathParams: ParsedUrlQuery
  seoAttributes: SeoAttributes
  breadcrumb: SeoBreadcrumbItem[]
}

export const getSeoBreadcrumb = ({
  pathParams,
  seoAttributes,
  breadcrumb
}: GetSeoBreadcrumbParams): SeoBreadcrumb[] => {
  if (!breadcrumb?.length) {
    return []
  }

  const seoBreadcrumb: SeoBreadcrumb[] = breadcrumb.map(
    ({type, label, path}) => ({
      type,
      name: label,
      path
    })
  )

  // Append the first filter as the last breadcrumb level, built on top of the
  // most-specific place path (the last entry we just mapped).
  const [firstFilter] = getSortedFilters(
    extractFilterSlugsFromTaxonomy(pathParams.taxonomy),
    seoAttributes
  )

  if (firstFilter) {
    seoBreadcrumb.push({
      type: 'filter',
      name: capitalizeFirstLetter(firstFilter.label),
      path: seoBreadcrumb.at(-1).path + buildFilterSuffix([firstFilter.slug])
    })
  }

  return seoBreadcrumb
}
